exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".copy-icon[data-v-d4980d9a]:hover{cursor:pointer}", "", {"version":3,"sources":["/home/webuser/profi-stout/releases/42/spa/src/pages/profile/profileEdit/CopyIcon.vue"],"names":[],"mappings":"AAEE,kCACE,cAAA,CAAA","file":"CopyIcon.vue?vue&type=style&index=0&id=d4980d9a&prod&scoped=true&lang=scss&","sourcesContent":["\n.copy-icon {\n  &:hover {\n    cursor: pointer;\n  }\n}\n\n"],"sourceRoot":""}]);

// exports
